// More proper implementation would be
// isDescriptor(obj) || isStamp(obj)
// but there is no sense since stamp is function and function is object.
module.exports = require('./object');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/is/composable.js
// module id = 236
// module chunks = 0